<template>
  <div>
    <v-dialog
      max-width="420px"
      v-model="show"
      >
        <v-card>
          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">
            <v-card-title class="d-flex justify-space-between">
              <div class="loadflex"><span class="text-h6">Link Invoice |</span>&nbsp;<span style="font-size:15px;color:darkgrey">{{ item.tolinkreceipt }}</span>&nbsp;&nbsp;<div class="load"><v-progress-circular
                    color="primary"
                    indeterminate
                    :size="18"
                    :width="3"
                    v-show="loader"></v-progress-circular></div></div>
            </v-card-title>

            <v-card-text>
                <v-container class="mt-0 mx-0 px-0 mb-0">
                  <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-autocomplete
                          :items="invoices"
                          label="Select invoice"
                          v-model="item.invoice_id"
                          item-text="invoice_no"
                          item-value="id"
                          :search-input.sync="syncinvoices"
                          @change="(event) => selectedInvoice(event)"
                        >
                        </v-autocomplete>
                      </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="default darken-1"
                  text
                  @click.stop="show = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="submit"
                >
                  Submit
                </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
    </v-dialog>
  </div>
</template>

<style>
  .modal-payment{
    max-width:550px !important;
  }
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import Vue from 'vue'

export default {
  name: 'linkpayment',
  components: {
  },
  data: () => ({
    fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          menu2: false,
          date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        valid: true,
        paymentmodes: null,
        syncinvoices: null,
        isBusy: false,
        loading: false,
        disabled: false,
        item:{
           id: "",
           amount: "",
           payment_mode_id: '',
           reference_no: "",
           invoice_id: "",
           driverid: "",
           tolinkreceipt: "",
           date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
           _method:"patch"
        },
       modes: [],
       invoices: []
  }),
  methods: {

    selectedInvoice(id){
      let index = this.invoices.filter(item => item.id === id );
      this.item.amount = index[0].amount
    },

    async getData(){
        this.$store.state.componentloader = true
        await axios.get(`/driver/payment/modes/${this.item.driverid}`).then(response=>{
            this.$store.state.componentloader = false
            if(response.data.status == parseInt(200)) {
              this.modes = response.data.modes
              this.invoices = response.data.invoices
            }
        }).catch(error=>{
          this.$store.state.componentloader = false
          console.log(error)
        })
      },
    submit(){
      this.loading = true

      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      let fd = new FormData();
      fd.append('id',this.item.id)
      fd.append('invoice_id',this.item.invoice_id)
      fd.append('driver_id',this.item.driverid)

      axios.post('/driver/receipt/link', fd, config).then(response=>{
          this.loading = false
        if(response.data.status == parseInt(200)) {

          let index = this.$store.state.driverreceipts.findIndex(data => data.id == response.data.receipt.id);
          if (index > -1) {
            this.$set(this.$store.state.driverreceipts, index, response.data.receipt);
          }

          this.$toast.success('Payment linked successfully','Success',{position: 'topRight',timeout: 7000,})
          this.clear()
          this.show = false
        }
          
        })
        .catch(() => {
          this.loading = false
        })
    },

    clear() {
      this.item.payment_mode_id = null
      this.item.amount = ""
      this.item.reference_no = ""
      this.item.invoice_id = ""
      this.item.driverid = ""
      this.item.date = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
    }
  },
  watch: {
      data: function(newVal, oldVal) {
        if(newVal !== null) {
          this.item.id = newVal.id
          this.item.driverid = newVal.driverid
          this.item.tolinkreceipt = newVal.tolinkreceipt
        }
      },
      show: function (newVal,oldVal) {
        if(newVal == true) {
          this.getData()
        }
      }
  },
  props: {
     value: Boolean
  },
  computed: {
    loader() {
      return this.$store.state.componentloader
    },
    data() {
      return this.$store.state.linkdriverpaymentdata
    },
    timepickerdate () {
      return this.date ? moment(this.date).format('Do MMM YYYY') : ''
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },
  mounted() {
  },
  created() {}
}
</script>